<div [class]="'avatar overline-o4 ' + style" [ngClass]="{'avatar--disabled': disabled}">
  <img *ngIf="type === 'image'" src="{{data}}" alt="'image'">
  <mat-icon *ngIf="type === 'icon'" [svgIcon]="data" [class]="style"></mat-icon>
  <div *ngIf="type === 'initials' || type === 'iconInitials'">{{Helper.getInitials(data)}}</div>
</div>
